export enum CLOSETPlanType {
  NONE,
  FREE,
  TRIAL,
  ADVANCED,
  ENTERPRISE,
  ADVANCED_INVOICE_PAYMENT,
  STANDARD = 6,
  PREMIUM = 7,
  STANDARD_TRIAL = 8,
  PREMIUM_TRIAL = 9,
  STANDARD_INVOICE_PAYMENT = 10,
  PREMIUM_INVOICE_PAYMENT = 11,
  ACADEMIC = 12,
  NEW_FREE = 99,
}

export enum CLOSETPaymentMethod {
  NONE = 0, // free or trial
  INVOICE = 1,
  STRIPE = 2,
}

export enum CLOSETPaymentCurrency {
  USD = 'USD',
  EUR = 'EUR',
}
